module.exports = __webpack_public_path__ + "img/advertisement.0798db84.jpg";